import { z } from 'zod/v4';
import { RegionSelector } from '../types/regions.types';

export const createRegionSchema = z.object({
  countryIds: z.array(z.string()).min(1, 'Debe seleccionar al menos un país.'),
  selector: z.nativeEnum(RegionSelector).refine((val) => val !== undefined, {
    message: 'El tipo es requerido.',
  }),
  name: z.string().min(1, 'El nombre es requerido').trim(),
  parentId: z.string().optional().nullable(),
});

export type CreateRegionFormValues = z.infer<typeof createRegionSchema>;

export const updateRegionSchema = z.object({
  name: z.string().min(1, 'El nombre es requerido').trim(),
  selector: z.nativeEnum(RegionSelector).optional(),
  countryIds: z.array(z.string()).min(1, 'Debe seleccionar al menos un país.'),
  parentId: z.string().optional().nullable(),
});

export type UpdateRegionFormValues = z.infer<typeof updateRegionSchema>;
